module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"userGroupsManagement":"ユーザーグループ管理","addUserGroup":"ユーザーグループを追加","userGroup":"ユーザーグループを追加","actions":"編集","confirmDelete":"確認","promptDelete":"選択されたグループを削除してもよろしいでしょうか？","successMessage":"ユーザーグループが正常に保存されました。","deleteMessage":"ユーザーは正常に削除されました。 ","updateMessage":"ユーザーグループが正常に追加されました。"}}')
  delete Component.options._Ctor
}
